import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import dateRangeReducer from "./reducers/dateRange";
import projectsReducer from "./reducers/projects";
import congressReducer from "./reducers/congress";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  dateRange: dateRangeReducer,
  projects: projectsReducer,
  congress: congressReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
